<div appTableOfContents appStickyHeaders class="container-fluid">
  <div id="civil-case-title" class="sticky-header-offset table-of-contents-header-offset">
    <div id="civil-case-title-text">
      Court Case <span class="field-code">V017a,V003a</span><span style="font-weight:bold">{{civilCase.getCaseCounty()}}</span> County <span style="font-weight:bold">{{civilCase.getCaseNumber()}}</span><span class="field-code">V085a</span>: {{civilCase.getCaseCaption()}} {{civilCase.getCaseTypeCaptionDescription()}}
      </div>
      <div id="civil-case-datetime-of-last-update"><span class="field-code">V517</span>
        <span class="search-record-last-updated-info">The displayed information was last updated from the system of record on {{civilCase.searchRecordLastUpdateDate | date:'MM/dd/yyyy'}} at {{civilCase.searchRecordLastUpdateDate | date:'hh:mm a'}}.</span>
      </div>
  </div>

  <div id="civil-case-main-content" class="row main-content" >
    <nav id="table-of-contents-nav" [ngClass]="{'closed': !tocOpen}">
      <ul id="table-of-contents-nav-list" class="nav nav-pills nav-stacked">
        <!-- TODO only show judgments with money owed -->
        <li *ngIf="civilCase.getAbstractList('J').length !== 0 || civilCase.getPreJAAbstractList().length !== 0" id="table-of-contents-nav-what-do-i-owe">
          <div class="dropdown">
              <a class="dropdown-toggle" id="toc-judgment-abstracts-link" type="button" href="" data-toggle="dropdown">What do I owe?
              <span class="caret"></span></a>
              <ul class="dropdown-menu scrollable-menu" role="menu" aria-labelledby="toc-judgment-abstracts-link">
                <li *ngFor="let judgmentAbstract of civilCase.getAbstractPrePostList('J')" role="presentation">
                    <a role="menuitem" tabindex="-1" class="toc-activate-exclude" [href]="'#J-parties-' + judgmentAbstract.getAbstractJudgmentNumber()" data-scrollspy-offset-px="40">See section Judgment {{judgmentAbstract.getAbstractJudgmentNumber()}} - Parties Affected by this Judgment and Payoff Amounts</a>
                </li>
              </ul>
            </div>
        </li>
            
        <li class="inline">
          <a id="TOC Parties" href="#section-party">Parties</a><a class="dropdown-toggle" data-toggle="dropdown" href="#"><span class="caret"></span></a>
          <ul class="dropdown-menu scrollable-menu" role="menu">
            <li *ngFor="let party of civilCase.getPartyList()">
              <a [href]="'#P-' + party.getPartyKey()" data-scrollspy-offset-px="50">{{party.getName()}} ({{party.getPartyRole()}} {{party.getPartyNumber()}})</a>
            </li>
          </ul>
        </li>
        <li class="inline"><a id="TOC Case Information" href="#section-case-information">Case Information</a></li>
       <!-- 
         <li [ngClass]="caseDocuments.hasDocuments() ? 'show-case-documents' : 'hide-case-documents'">
          <a id="TOC Documents" href="#section-documents">Documents</a></li>
       -->
        <li class="inline" *ngIf="civilCase.getServiceOfDocumentsList().length !== 0"><a id="TOC Service of Documents" href="#section-service">Service of Documents</a></li>
        <li class="inline"><a id="TOC Filings" href="#section-filings">Filings</a></li>
        <li class="inline" *ngIf="civilCase.getAbstractList('J').length !== 0 || civilCase.getPreJAAbstractList().length !== 0">
          <a id="TOC Judgment Abstracts" href="#section-judgment-abstracts">Judgment Abstracts</a><a class="dropdown-toggle" data-toggle="dropdown" href="#"><span class="caret"></span></a>
          <ul class="dropdown-menu scrollable-menu" role="menu">
            <li *ngFor="let judgmentAbstract of civilCase.getAbstractPrePostList('J')">
              <a [href]="'#J-' + judgmentAbstract.getAbstractJudgmentNumber()" data-scrollspy-offset-px="40">Judgment {{judgmentAbstract.getAbstractJudgmentNumber()}}</a>
            </li>
          </ul>
        </li>
        <li class="inline" *ngIf="civilCase.getAbstractList('Q').length !== 0"><a id="TOC Special Abstracts" href="#section-special-abstracts">Special Abstracts</a></li>
        <li class="inline" *ngIf="civilCase.getTranscriptList().length !== 0"><a id="TOC Transcripts of Judgment to Other County" href="#section-transcripts">Transcripts of Judgments</a></li>
        <li class="inline" *ngIf="civilCase.getTransferedToCaseNumber() !== '-' || civilCase.getTransferedFromCaseNumber() !== '-'|| civilCase.getAppealedIssueList().length !== 0 || civilCase.getAppealToCase() !== '-' || civilCase.getClockDateByCaseEventCode('INAP') !== ''">
          <a id="TOC Transfers and Appeals" href="#section-transfers-appeals">Transfers and Appeals</a></li>
        <li class="inline" *ngIf="civilCase.getAttorneyList().length !== 0"><a id="TOC Attorneys" href="#section-attorneys">Attorneys</a></li>
<!--    <li><a id="TOC Case Event History" href="#section-event-history" *ngIf="civilCase.getCaseEventHistoryList().length !== 0">Case Event History</a></li> -->
        <br>
        <li *ngIf="!isProd()"><div class="show-field-code" title="{{showFieldCodeAction}}" (click)="showFieldCode()">    </div></li>
      </ul>
    </nav>

    <div id="content-column" class="panel-group" [ngClass]="{'toc-opened': tocOpen, 'toc-closed': !tocOpen}">
      <div id="civil-case-view-toc-controls-outer-div" (click)="toggleTableOfContents()"
        [title]="tocOpen ? 'Close table of contents' : 'Open table of contents'">
        <div id="civil-case-view-toc-controls-inner-div">
            <i id="civil-case-view-toc-controls-arrow" class="fa fa-2x" [ngClass]="{'fa-chevron-circle-left': tocOpen, 'fa-chevron-circle-right': !tocOpen}" aria-hidden="true"></i>
          </div>
      </div>

      <!-- Begin Parties -->
      <div class="panel panel-default page" id="section-party">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Parties</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-parties [civilCase]="civilCase"></app-parties>
        </div>
        <!--<div class="title-bar panel-heading">-->
        <div class="title-bar">
          <h3 id="Parties" class="panel-title summary-label">Parties</h3>
        </div>
      </div>
      <!-- End Parties -->

      <!-- Begin Case Information -->
      <div class="panel panel-default page" id="section-case-information">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Case Information</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-civil-case-information [civilCase]="civilCase"></app-civil-case-information>
        </div>
        <div class="title-bar">
          <h3 id="Case Information" class="panel-title summary-label">Case Information</h3>
        </div>
      </div>
      <!-- End Case Information -->

      <!-- Begin Documents 
      <div class="panel panel-default page" id="section-documents"
        [ngClass]="caseDocuments.hasDocuments() ? 'show-case-documents' : 'hide-case-documents'">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Documents</h3>
        </div>
        -->
        <!-- <div class="panel-collapse collapse in" style="height: auto;"> -->
        <!--   <app-documents #caseDocuments [civilCase]="civilCase"></app-documents> -->
        <!-- </div> -->
        <!--
        <div class="title-bar">
          <h3 id="Documents" class="panel-title summary-label">Documents</h3>
        </div>
      </div>
    -->
      <!-- End Documents -->

      <!-- Begin Service of Documents -->
      <div class="panel panel-default page" id="section-service" *ngIf="civilCase.getServiceOfDocumentsList().length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Service of Documents</h3>
        </div>
        <app-service-documents [civilCase]="civilCase"></app-service-documents>
        <div class="title-bar">
          <h3 id="Service of Documents" class="panel-title summary-label">Service of Documents</h3>
        </div>
      </div>
      <!-- End Service of Documents -->

      <!-- Begin Pleadings -->
      <div class="panel panel-default page" id="section-filings">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Filings</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-pleadings [civilCase]="civilCase"></app-pleadings>
        </div>
        <div class="title-bar">
          <h3 id="filings" class="panel-title summary-label">Filings</h3>
        </div>
      </div>
      <!-- End Pleadings -->

      <!-- Begin Judgment Abstracts  *Note: both Abstract sections use the same component and template code -->
      <div class="panel panel-default page" id="section-judgment-abstracts" *ngIf="civilCase.getAbstractList('J').length !== 0 || civilCase.getPreJAAbstractList().length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Judgment Abstracts</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-judgments [civilCase]="civilCase" [abstractCode]="getAbstractJQCode('J')"></app-judgments>
        </div>
        <div class="title-bar">
          <h3 id="Judgment Abstracts" class="panel-title summary-label">Judgment Abstracts</h3>
        </div>
      </div>
      <!-- End Judgment Abstracts -->

      <!-- Begin Special Abstracts -->
      <div class="panel panel-default page" id="section-special-abstracts" *ngIf="civilCase.getAbstractList('Q').length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Special Abstracts</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-judgments [civilCase]="civilCase" [abstractCode]="getAbstractJQCode('Q')"></app-judgments>
        </div>
        <div class="title-bar">
          <h3 id="Special Abstracts" class="panel-title summary-label">Special Abstracts</h3>
        </div>
      </div>
      <!-- End Special Abstracts -->

      <!-- Transcripts of Judgment -->
      <div class="panel panel-default page" id="section-transcripts" *ngIf="civilCase.getTranscriptList().length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Transcripts of Judgments to Other County</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-transcript [civilCase]="civilCase"></app-transcript>
        </div>
        <div class="title-bar">
          <h3 id="Transcripts of Judgment to Other County" class="panel-title summary-label">Transcripts of Judgment to Other County</h3>
        </div>
      </div>
      <!-- Judgment Transcripts -->

      <!-- Begin Transfers and Appeals -->
      <div class="panel panel-default page" id="section-transfers-appeals"
              *ngIf="civilCase.getTransferedToCaseNumber() !== '-' || civilCase.getTransferedFromCaseNumber() !== '-'|| civilCase.getAppealedIssueList().length !== 0 || civilCase.getAppealToCase() !== '-' || civilCase.getClockDateByCaseEventCode('INAP') !== ''">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Transfers and Appeals</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-transfer-appeals [civilCase]="civilCase"></app-transfer-appeals>
        </div>
        <div class="title-bar">
          <h3 id="Transfers and Appeals" class="panel-title summary-label">Transfers and Appeals</h3>
        </div>
      </div>
      <!-- End Appeals and Transfers -->

      <!-- Begin Attorneys -->
      <div class="panel panel-default page" id="section-attorneys" *ngIf="civilCase.getAttorneyList().length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Attorneys</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-attorneys [civilCase]="civilCase"></app-attorneys>
        </div>
        <div class="title-bar">
          <h3 id="Attorneys" class="panel-title summary-label">Attorneys</h3>
        </div>
      </div>
      <!-- End Attorneys -->

      <!-- Begin Event History 
      <div class="panel panel-default page" id="section-event-history" *ngIf="civilCase.getCaseEventHistoryList().length !== 0">
        <div class="panel-heading">
          <h3 class="panel-title summary-label">Case Event History</h3>
        </div>
        <div class="panel-collapse collapse in" style="height: auto;">
          <app-case-event-history [civilCase]="civilCase"></app-case-event-history>
        </div>

        <div class="title-bar">
          <h3 id="Case Event History" class="panel-title summary-label">Case Event History</h3>
        </div>
      </div>
      -->
      <!-- End Event History -->
      <div style="height:1000px" id="extendedSpaces"></div>
    </div>
    </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/civil-case-view.component.html